import { useContext, useEffect, useRef } from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { WorkspaceContext } from "src/context/workspace";
import { classNames } from "src/helpers/classNames";
import useDevice from "src/hooks/useDevice";
import useIframeResize from "src/hooks/useIframeResize";
import { useSiteSettings } from "src/context/SiteSettingsContext";

export default function QuickSightEmbedProgrammaticFiltering({ content }) {
  const { details: workspaceDetails, menuType } = useContext(WorkspaceContext);
  const { site } = useSiteSettings();
  const { maxWidth } = useIframeResize({ workspaceDetails, site });
  const device = useDevice();
  const iframeWrapperRef = useRef(null);

  const isExtension = window.location.protocol === "chrome-extension:";

  useEffect(() => {
    if (isExtension) {
      window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));
      return;
    }
    const wrapper = iframeWrapperRef.current;
    const iframe = wrapper?.querySelector("iframe");
    if (!iframe) return;

    const handleLoad = () => {
      window.dispatchEvent(new CustomEvent("domo:iframe-loaded", {}));
    };

    iframe.addEventListener("load", handleLoad);
    return () => iframe.removeEventListener("load", handleLoad);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content.embedUrl]);

  const handleOpenInNewTab = () => {
    if (content?.embedUrl) {
      window.open(content.embedUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className={classNames("relative flex h-full w-full items-center justify-center", menuType === "horizontal" || menuType === "vertical" ? "" : "")}>
      {isExtension
        ? content?.embedUrl && (
            <button
              onClick={handleOpenInNewTab}
              className="flex items-center gap-2 rounded-lg bg-highlightColor px-4 py-2 font-medium text-white shadow transition hover:opacity-80">
              Open Dashboard
              <ArrowTopRightOnSquareIcon className="h-5 w-5" />
            </button>
          )
        : content?.embedUrl && (
            <div
              ref={iframeWrapperRef}
              className="mx-auto h-full w-full overflow-auto"
              style={{
                maxWidth: device === "desktop" ? maxWidth || "100%" : "100%",
              }}>
              <iframe
                id="iframe"
                title="QuickSight Embed"
                src={content.embedUrl}
                width="100%"
                height="100%"
              />
            </div>
          )}
    </div>
  );
}
